export default "__VITE_ASSET__CPf0ZMY7__"